import Loader from './components/Loader';
import React, { useState, useEffect } from 'react';

// Define a mapping of component names to components
const componentMap: Record<string, React.LazyExoticComponent<() => JSX.Element>> = {
  Login: React.lazy(() => import('./pages/Auth/Login')),
  Dashboard: React.lazy(() => import('./pages/Dashboard')),
  Welcome: React.lazy(() => import('./pages/Welcome')),
  Repositories: React.lazy(() => import('./pages/PricingSettings/Repositories')),
  Users: React.lazy(() => import('./pages/Administration/Users')),
  NotFound: React.lazy(() => import('./pages/ErrorPage')),
  ForgetPassword: React.lazy(() => import('./pages/Auth/ForgetPassword')),
  ResetPassword: React.lazy(() => import('./pages/Auth/ResetPassword')),
  DataController: React.lazy(() => import('./pages/PricingSettings/DataController')),
  Results: React.lazy(() => import('./pages/Simulations/Results')),
  Input: React.lazy(() => import('./pages/Simulations/Input')),
  PricingConfiguration: React.lazy(() => import('./pages/PricingSettings/PricingConfiguration')),
  AiguillageTarifaire: React.lazy(() => import('./pages/PricingSettings/AiguillageTarifaire')),
  Audit: React.lazy(() => import('./pages/Administration/Audit')),
  JsonSimulator: React.lazy(() => import('./pages/JsonSimulator')),
  DMUpdater: React.lazy(() => import('./pages/DMUpdater'))
};

function DynamicComponentLoader({ componentName }: Readonly<{ componentName: string }>): JSX.Element {
  const [Component, setComponent] = useState<React.LazyExoticComponent<() => JSX.Element> | null>(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (componentMap[componentName]) {
        const component = componentMap[componentName];
        setComponent(component);
      } else {
        console.error(`Component "${componentName}" not found`);
      }
    };

    loadComponent();

    // Cleanup function
    return () => {
      setComponent(null);
    };
  }, [componentName]);

  return (
    <React.Suspense fallback={<Loader />}>
      {Component && <Component />}
    </React.Suspense>
  );
};

export default DynamicComponentLoader;
